export enum PayInterval {
  None,
  Weekly,
  Monthly,
}
